import { render, staticRenderFns } from "./SelectItemsComponent.vue?vue&type=template&id=1425039b&scoped=true&"
import script from "./SelectItemsComponent.vue?vue&type=script&lang=ts&"
export * from "./SelectItemsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SelectItemsComponent.vue?vue&type=style&index=0&id=1425039b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425039b",
  null
  
)

export default component.exports